import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { publicRoutes, privateRoutes } from "./routes";
import PrivateRoute from "./components/PrivateRoute";
import { PopupProvider } from "./components/common/Popup";
import "./App.css";

function App() {
  return (
    <PopupProvider>
      <Router>
        <Routes>
          {/* rotas públicas */}
          {publicRoutes.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))}

          {/* rotas privadas */}
          {privateRoutes.map(({ path, element }) => (
            <Route
              key={path}
              path={path}
              element={<PrivateRoute>{element}</PrivateRoute>}
            />
          ))}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </PopupProvider>
  );
}

export default App;
